export const useAnalytics = () => {
  // Generate or get session ID from localStorage
  const getSessionId = (): string => {
    if (process.server) return ''
    
    let sessionId = localStorage.getItem('visitor_session_id')
    if (!sessionId) {
      sessionId = 'vs_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9)
      localStorage.setItem('visitor_session_id', sessionId)
    }
    return sessionId
  }

  // Track a visitor action
  const trackAction = async (
    actionType: 'page_view' | 'auth_attempt' | 'auth_success' | 'sign_up_start' | 'sign_up_complete',
    options: {
      page?: string
      actionData?: any
    } = {}
  ) => {
    if (process.server) return

    try {
      const sessionId = getSessionId()
      const route = useRoute()
      
      await $fetch('/api/analytics/track-session', {
        method: 'POST',
        body: {
          sessionId,
          actionType,
          actionData: options.actionData,
          page: options.page || route.path,
          userAgent: navigator.userAgent,
          referrer: document.referrer || null,
          landingPage: sessionStorage.getItem('landing_page') || route.path
        }
      })
    } catch (error) {
      // Silently fail analytics to not break user experience
      console.warn('Analytics tracking failed:', error)
    }
  }

  // Track page view
  const trackPageView = (page?: string) => {
    if (process.server) return
    
    // Store landing page for new sessions
    if (!sessionStorage.getItem('landing_page')) {
      const route = useRoute()
      sessionStorage.setItem('landing_page', page || route.path)
    }
    
    trackAction('page_view', { page })
  }

  // Track auth attempt
  const trackAuthAttempt = (method: 'email' | 'google' | 'github' = 'email') => {
    trackAction('auth_attempt', { 
      actionData: { method }
    })
  }

  // Track successful auth
  const trackAuthSuccess = (method: 'email' | 'google' | 'github' = 'email') => {
    trackAction('auth_success', { 
      actionData: { method }
    })
  }

  // Track sign up start
  const trackSignUpStart = () => {
    trackAction('sign_up_start')
  }

  // Track sign up completion
  const trackSignUpComplete = () => {
    trackAction('sign_up_complete')
  }

  return {
    trackAction,
    trackPageView,
    trackAuthAttempt,
    trackAuthSuccess,
    trackSignUpStart,
    trackSignUpComplete
  }
}
